import { Injectable } from '@angular/core';
import { Task } from 'src/app/models/domain';
import { TaskDataService } from 'src/app/services';
import { PagedSapService } from 'src/app/state/paged-sap-service';

@Injectable({
  providedIn: 'root',
})
export class TaskService extends PagedSapService<Task> {
  public constructor(taskDataService: TaskDataService) {
    super(taskDataService);
  }
}
